import React from "react";

import s from "./CustomInput.module.css";

const CustomInput = React.forwardRef(
  ({ type, onChange, value, disabled = false, ...rest }, ref) => {
    return (
      <input
        ref={ref}
        className={s.input}
        type={type}
        onChange={onChange}
        value={value}
        disabled={disabled}
        {...rest}
      />
    );
  }
);

CustomInput.displayName = "CustomInput";

export { CustomInput };
